import { site, fullAddress } from "@/config/site";
import { SEO } from "@/components/site/SEO";
import { Reveal } from "@/components/site/Reveal";

const sections = [
  {
    title: "About these terms",
    body: `These terms govern your use of the ${site.name} website, operated by ${site.legalName} of ${fullAddress}. By using this site you accept these terms. Separate terms and conditions are provided with every quotation and apply to any order you place with us.`,
  },
  {
    title: "The service we describe",
    body: "This website describes our made-to-measure blinds and shutters service, including free home consultations, professional measuring, quotation and installation across Birmingham and the surrounding area. Product images on this site are illustrative; actual fabrics, materials and finishes are viewed and selected during your home visit.",
  },
  {
    title: "Enquiries and quotations",
    body: "Submitting an enquiry through this site does not create a contract. A contract for supply and installation is formed only when you accept a written quotation and any required deposit is received. Quotations are valid for the period stated on them.",
  },
  {
    title: "Website content",
    body: "We work to keep the information on this site accurate, but we do not warrant that it is complete or error-free, and we may update it at any time. Nothing on this site constitutes professional advice.",
  },
  {
    title: "Intellectual property",
    body: `All content on this site — text, design and imagery — belongs to or is licensed to ${site.legalName}. You may not reproduce it without our written permission.`,
  },
  {
    title: "Liability",
    body: "Nothing in these terms excludes or limits our liability for death or personal injury caused by negligence, for fraud, or for anything else that cannot be excluded by law. Otherwise, to the extent permitted by law, we are not liable for indirect or consequential losses arising from use of this website. Your statutory rights are not affected.",
  },
  {
    title: "Governing law",
    body: "These terms are governed by the laws of England and Wales, and the courts of England and Wales have exclusive jurisdiction.",
  },
  {
    title: "Contact",
    body: `Questions about these terms? Email ${site.email} or call ${site.phone.display}.`,
  },
];

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms & Conditions | My Blinds Company"
        description="Terms and conditions for using the My Blinds Company website."
        path="/terms-and-conditions"
      />
      <section className="bg-warm-50 py-14 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <h1 className="font-serif text-4xl text-slate-900 tracking-tight">Terms & Conditions</h1>
            <p className="mt-3 text-sm text-slate-500">Last updated: July 2026</p>
          </Reveal>
          <div className="mt-10 space-y-8">
            {sections.map((s) => (
              <Reveal key={s.title}>
                <section>
                  <h2 className="font-sans text-lg font-semibold text-slate-900 mb-2">{s.title}</h2>
                  <p className="text-sm sm:text-base leading-relaxed text-slate-600">{s.body}</p>
                </section>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
